import { render, staticRenderFns } from "./TgCjLinkNav.vue?vue&type=template&id=c36aa288&"
import script from "./TgCjLinkNav.vue?vue&type=script&lang=js&"
export * from "./TgCjLinkNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports